import React, { useState } from 'react';
import { ALPHABET } from '../../../utils/constants';

export const MultipleChoiceImageOption = ({activeRadio, completed, getOptionMods, name, option, index, handleChange}) => {
  
  const [focused, setFocused] = useState(false);

  return (
    <div className="task__option-wrapper">
      <label className={`task__option ${getOptionMods(index)} ${focused ? ' task__option--focused' : ''}`}>
        <span className="task__option-letter">{ALPHABET[index]}</span>
        <img src={`${process.env.PUBLIC_URL}/resources/tasks/images/${option.$.src}`} alt={option.$.alt} />
        <input
          type="radio"
          checked={activeRadio === index}
          name={name}
          disabled={completed}
          onChange={() => handleChange(index)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        />
        <span aria-hidden="true"></span>
      </label>
    </div>
  )
}